import {
  memo,
  forwardRef,
  useState,
  useCallback,
} from 'react';
import type {
  ForwardedRef,
  ReactElement,
} from 'react';

import { Button } from '../Button';
import { Modal } from '../Modal';

import type {
  ButtonModalProps,
} from './types';

function ButtonModalInner(
  {
    renderModal,
    modalSize,
    hasCloseButton,
    isHideOnBackdropClick,
    useState: useStateProp = useState,
    useCallback: useCallbackProp = useCallback,
    ...buttonProps
  }: ButtonModalProps & {
    useState?: typeof useState;
    useCallback?: typeof useCallback;
  },
  ref: ForwardedRef<HTMLElement>,
): ReactElement {
  const [isOpen, setIsOpen] = useStateProp(false);

  const openModal = useCallbackProp(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallbackProp(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <Button
        {...buttonProps}
        componentProps={{
          type: 'button',
        }}
        onClick={openModal}
        ref={ref}
      />

      <Modal
        size={modalSize}
        hasCloseButton={hasCloseButton}
        isHideOnBackdropClick={isHideOnBackdropClick}
        show={isOpen}
        onHide={closeModal}
      >
        {
          (isOpen && renderModal({
            closeModal,
          })) as ReactElement
        }
      </Modal>
    </>
  );
}

export const ButtonModal = memo(forwardRef(ButtonModalInner));
